import LoggerService from '../../../services/logger.service'

export default class PcrLoggerService extends LoggerService {
  static crudError(pcrID: string, userId: string, serviceId: string, error: any) {
    const message = `Error performing CRUD for PCR -> pcrId: ${pcrID} serviceId: ${userId} userId: ${serviceId} with error: ${error?.toString()}`
    LoggerService.error(message)
  }
}
